// src/components/organisms/ProfileSettings.js

import React from 'react';
import { Container } from '@mui/material';
import ProfileForm from '../molecules/UserProfile/Edit/ProfileForm';

const ProfileSettings = () => {
  return (
    <Container maxWidth="md">
      <ProfileForm />
    </Container>
  );
};

export default ProfileSettings;
